import React from "react";
import classNames from "classnames";
import { string } from "prop-types";
import styles from "../../styles/app.module.scss";

const Spinner = ({ className }) => (
  <div className={classNames(styles.spinner, className)} />
);

Spinner.propTypes = {
  className: string
};

Spinner.defaultProps = {
  className: ""
};

export default Spinner;
